import _slicedToArray from "/vercel/path1/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/vercel/path1/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  border-top: 1px solid var(--card-hairline-soft-color);\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  overflow: auto;\n  outline: none;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n\n  &:after {\n    content: '';\n    display: block;\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: -1px;\n    border-bottom: 1px solid var(--card-hairline-soft-color);\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  flex: 1;\n  min-height: 0;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  min-height: 0;\n  max-height: 100%;\n  overflow: hidden;\n\n  &&:not([hidden]) {\n    display: flex;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  &&:not([hidden]) {\n    display: flex;\n  }\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    && {\n      position: absolute;\n    }\n\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    &&:not([hidden]) {\n      display: flex;\n    }\n    align-items: center;\n    justify-content: center;\n    padding: 1.25em;\n    outline: none;\n    background: ", ";\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { forwardRef, useCallback, useEffect, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import { Box, Button, Card, Container, Flex, Text } from '../../atoms';
import { focusFirstDescendant, focusLastDescendant } from '../../helpers';
import { useClickOutside, useGlobalKeyDown } from '../../hooks';
import { Layer, Portal, useLayer } from '../../utils';
var Root = styled(Layer)(function (_ref) {
  var theme = _ref.theme;
  var color = theme.sanity.color.base;
  return css(_templateObject(), color.shadow.penumbra);
});
var DialogContainer = styled(Container)(_templateObject2());
var DialogCardRoot = styled(Card)(_templateObject3());
var DialogLayout = styled(Flex)(_templateObject4());
var DialogHeader = styled(Card)(_templateObject5());
var DialogContent = styled(Box)(_templateObject6());
var DialogFooter = styled(Box)(_templateObject7());
var DialogCard = forwardRef(function (_ref2, ref) {
  var cardRadius = _ref2.cardRadius,
      cardShadow = _ref2.cardShadow,
      children = _ref2.children,
      footer = _ref2.footer,
      header = _ref2.header,
      id = _ref2.id,
      onClose = _ref2.onClose,
      scheme = _ref2.scheme,
      width = _ref2.width;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      rootElement = _useState2[0],
      setRootElement = _useState2[1];

  var contentRef = useRef(null);

  var _useLayer = useLayer(),
      isTopLayer = _useLayer.isTopLayer;

  var labelId = "".concat(id, "_label");
  useEffect(function () {
    // On mount: focus the first interactive element in the contents
    if (contentRef.current) {
      focusFirstDescendant(contentRef.current);
    }
  }, []);
  useGlobalKeyDown(useCallback(function (event) {
    if (!isTopLayer) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopPropagation();
      if (onClose) onClose();
    }
  }, [isTopLayer, onClose]));
  useClickOutside(useCallback(function () {
    if (!isTopLayer) return;
    if (onClose) onClose();
  }, [isTopLayer, onClose]), [rootElement]);
  var setRef = useCallback(function (el) {
    setRootElement(el);
    if (typeof ref === 'function') ref(el);else if (ref) ref.current = el;
  }, [ref]);
  return React.createElement(DialogContainer, {
    width: width
  }, React.createElement(DialogCardRoot, {
    radius: cardRadius,
    ref: setRef,
    scheme: scheme,
    shadow: cardShadow
  }, React.createElement(DialogLayout, {
    direction: "column"
  }, React.createElement(DialogHeader, null, React.createElement(Flex, null, React.createElement(Box, {
    flex: 1,
    padding: 4
  }, header && React.createElement(Text, {
    id: labelId,
    weight: "semibold"
  }, header)), React.createElement(Box, {
    padding: 2
  }, React.createElement(Button, {
    "aria-label": "Close dialog",
    icon: "close",
    mode: "bleed",
    onClick: onClose,
    padding: 3
  })))), React.createElement(DialogContent, {
    flex: 1,
    ref: contentRef,
    tabIndex: -1
  }, children), footer && React.createElement(DialogFooter, null, footer))));
});
DialogCard.displayName = 'DialogCard';
export var Dialog = forwardRef(function (props, ref) {
  var _props$cardRadius = props.cardRadius,
      cardRadius = _props$cardRadius === void 0 ? 2 : _props$cardRadius,
      _props$cardShadow = props.cardShadow,
      cardShadow = _props$cardShadow === void 0 ? 4 : _props$cardShadow,
      children = props.children,
      footer = props.footer,
      header = props.header,
      id = props.id,
      onClose = props.onClose,
      scheme = props.scheme,
      _props$width = props.width,
      width = _props$width === void 0 ? 0 : _props$width,
      restProps = __rest(props, ["cardRadius", "cardShadow", "children", "footer", "header", "id", "onClose", "scheme", "width"]);

  var preDivRef = useRef(null);
  var postDivRef = useRef(null);
  var cardRef = useRef(null);
  var handleFocus = useCallback(function (event) {
    var target = event.target;
    var cardElement = cardRef.current;

    if (!cardElement) {
      return;
    }

    if (target === preDivRef.current) {
      focusLastDescendant(cardElement);
      return;
    }

    if (target === postDivRef.current) {
      focusFirstDescendant(cardElement);
      return;
    }
  }, []);
  var labelId = "".concat(id, "_label");
  return React.createElement(Portal, null, React.createElement(Root, Object.assign({}, restProps, {
    "aria-labelledby": labelId,
    "aria-modal": true,
    id: id,
    onFocus: handleFocus,
    ref: ref,
    role: "dialog"
  }), React.createElement("div", {
    ref: preDivRef,
    tabIndex: 0
  }), React.createElement(DialogCard, {
    cardRadius: cardRadius,
    cardShadow: cardShadow,
    footer: footer,
    header: header,
    id: id,
    onClose: onClose,
    ref: cardRef,
    scheme: scheme,
    width: width
  }, children), React.createElement("div", {
    ref: postDivRef,
    tabIndex: 0
  })));
});
Dialog.displayName = 'Dialog';